// extracted by mini-css-extract-plugin
export default {"HeadlineTitle":"Headline_HeadlineTitle__UfgUL","HeadlineSubtitle":"Headline_HeadlineSubtitle__E8InV"};